/**
 * Google Analytics 4 Utilities & Events
 */

if (typeof window.pushDataLayerEvent !== 'function') {
  window.pushDataLayerEvent = obj => {
    // Fallback for dataLayer
    window.dataLayer = window.dataLayer || [];

    // Clear the previous ecommerce object.
    window.dataLayer.push({ ecommerce: null });

    // Push new ecommerce dataLayer event
    window.dataLayer.push(obj);
  }
}

/**
 * GA4 DataLayer: custom event menu_open
 */
window.GA4_filter_click = (properties) => {
  try {
    pushDataLayerEvent({
      event: 'filter_click',
      ...properties
    });
  } catch (error) {
    console.log('GA4: filter_click', error);
  }
}

/**
 * GA4 DataLayer:  custom event search_interaction
 */
window.GA4_search_interaction = (properties) => {
  try {
    pushDataLayerEvent({
      event: 'search_interaction',
      ...properties
    });
  } catch (error) {
    console.log('GA4: search_interaction', error);
  }
}